import { render } from "./MyReceivedIOUBackRequests.vue?vue&type=template&id=e9564e94&scoped=true"
import script from "./MyReceivedIOUBackRequests.vue?vue&type=script&lang=js"
export * from "./MyReceivedIOUBackRequests.vue?vue&type=script&lang=js"

import "./MyReceivedIOUBackRequests.vue?vue&type=style&index=0&id=e9564e94&scoped=true&lang=css"

import exportComponent from "/var/www/vhosts/jahajibd.com/ia.jahajibd.com/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e9564e94"]])

export default __exports__